import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error caught by boundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // Auto-recover after 100ms
      setTimeout(() => {
        this.setState({ hasError: false, error: null });
      }, 100);

      return null; // Return nothing, let the navigation continue
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
